// 数据看板-授权管理
<template>
  <div class="DkbAuthorizationManage">
    <div class="operateArea">
      <div class="searchArea">
        <el-input class="text" v-model="authMData.paging.search" placeholder="可输入设备ID或设备名称进行搜索" clearable></el-input>
        <span class="btn-search" @click="getSpaceDeviceList('search')">搜&nbsp;索</span>
      </div>
      <div class="btnArea">
        <span class="btn" @click="goMore">更多设置</span>
      </div>
    </div>
    <div class="listBox" v-loading="authMData.loading" element-loading-background="rgba(240, 243, 248, 0.7)"
      element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <div class="listWrapper">
        <div class="list" v-for="(item, index) in authData" :key="index">
          <div class="one">
            <div class="num">{{(index+1)}}</div>
            <div class="name" :title="item.device_no_id">{{item.device_no_id}}</div>
          </div>
          <div class="two">
            <p class="text device_name" :title="item.device_name"><span class="blue">名称：</span>{{item.device_name}}</p>
            <p class="text"><span class="blue">类型：</span>{{item.device_type}}</p>
          </div>
          <div class="three">
            <template v-if="item.device_type_id==1">
              <p class="btn" @click="openAuthDio(index)" v-if="item.device_type_code != 'DEPOSIT'">授权用户</p>
              <p class="btn" @click="openAdminDio(index)">设置管理员</p>
            </template>
            <template v-else-if="item.device_type_code=='MULTIWAREHOUSE'">
              <p class="btn" @click="openAuthDio(index)">授权用户</p>
              <p class="btn" @click="openAdminDio(index)">设置管理员</p>
            </template>
            <template
              v-else-if="item.device_type_code=='CPL' || item.device_type_code=='EPSENSOR' || item.device_type_code=='WATERLEAKAGE' || item.device_type_code=='THAIO'"">
              <p class=" btn" @click="openAdminDio(index)">设置管理员</p>
            </template>
            <template v-else>
              <p class="btn" @click="openAuthDio(index)">授权用户</p>
            </template>
          </div>
        </div>
      </div>
      <el-pagination class="dkbPagination" @current-change="pageChange" :current-page.sync="authMData.paging.page"
        layout="prev, pager, next, jumper" :page-count="authMData.pageCount" v-if="authMData.pageCount > 1">
      </el-pagination>
    </div>

    <!-- 授权用户弹窗 -->
    <el-dialog class="DkbInnerDialog authDio" title="授权用户" :visible.sync="AuthDio" append-to-body>
      <div class="contDio">
        <el-form ref="form2" :rules="rules2" :model="authUserform">
          <el-form-item class="deviceInfo">
            <p class="tit">设备信息</p>
            <div class="flex">
              <div class="item">设备ID：<span>{{authUserform.device_no_id}}</span></div>
              <div class="item">设备名称：<span>{{authUserform.device_name}}</span></div>
              <div class="item">设备类型：<span>{{authUserform.device_type}}</span></div>
            </div>
          </el-form-item>
          <template v-if="authStep == '2'">
            <div class="dioTit">
              <p class="text">请选择授权箱格：</p>
              <p class="text s" v-if="authUserform.device_type_code == 'OFFICIALDEPOSIT'">
                共有{{authUserform.current_count}}人使用该设备，还可授权{{authUserform.count-authUserform.current_count}}人</p>
            </div>
            <div class="dioList">
              <div class="item" v-for="(item,index) in boxList" :key="index">
                <div :class="['size', item.box_size]">
                  <template v-if="item.box_size == 'A'">极大</template>
                  <template v-if="item.box_size == 'B'">大</template>
                  <template v-if="item.box_size == 'C'">中</template>
                  <template v-if="item.box_size == 'D'">小</template>
                  <template v-if="item.box_size == 'E'">极小</template>
                </div>
                <div class="des"><span class="num">{{item.box_number}}号</span>已授权：{{item.user_info}}</div>
                <p class="btn-auth" @click="authBox(item.box_number)">授权</p>
              </div>
            </div>
          </template>
          <template v-else>
            <el-form-item class="authInfo">
              <p class="tit2">授权时间:</p>
              <el-select v-model="authUserform.timeType" class="w110 inputbg">
                <el-option v-for="(item,index) in typeList" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <template v-if="authUserform.timeType=='1'">
                <el-date-picker class="inputbg datePicker" v-model="authUserform.time" type="daterange"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions">
                </el-date-picker>
              </template>
            </el-form-item>
            <el-form-item class="authInfo">
              <p class="tit2">使用次数:</p>
              <el-checkbox v-model="authUserform.isCount">无限次数</el-checkbox>
              <template v-if="authUserform.isCount==false">
                <el-input class="w110 inputbg" v-model="authUserform.frequency"></el-input><span class="ci">次</span>
              </template>
            </el-form-item>
            <el-form-item label="分享权限:">
              <el-checkbox v-model="authUserform.is_forbid">禁止分享</el-checkbox>
              <span class="hintColor">勾选后，授权用户将无法使用分享设备权限功能</span>
            </el-form-item>
            <div class="tit3">
              <div>授权用户:</div>
              <div class="col6">已勾选：{{authUserform.userInfo.length}}人</div>
            </div>
            <div class="authUserList flex">
              <div class="userTree DkbScroll">
                <el-tree ref="tree2" class="defineTree" :data="departList" highlight-current default-expand-all
                  node-key="id" :expand-on-click-node="false" :props="adminTreeProp" @node-click="getUserList">
                  <span class="custom-tree-node" slot-scope="{ node,data }">
                    <i class="defineIcon"
                      :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                    </i>
                    <span class="label" :class="data.id === treeCurrent ? 'selectedTree' : ''">{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
              <div class="checkList DkbScroll">
                <div class="search">
                  <el-input size="small" placeholder="请输入手机号码或姓名进行搜索" prefix-icon="el-icon-search"
                    v-model="authUserform.search" @input="searchUser"></el-input>
                  <el-checkbox class="checkAll" :indeterminate="isIndeterminate" v-model="checkAll"
                    @change="handleCheckAllChange"></el-checkbox>
                </div>
                <el-checkbox-group v-model="authUserform.userInfo" @change="handleCheckedCitiesChange">
                  <el-checkbox v-for="(item,index) in transList" :label="item.user_id" :key="index"
                    :disabled="authUserform.device_type_code === 'FEIBIFACE' && item.is_face !== 1">
                    {{item.phone_no}}-{{item.user_name}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </template>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <p class="btn btn-cancel" @click="closeAuthDio">取消</p>
        <template
          v-if="(authUserform.device_type == '办公魔方柜' || authUserform.device_type == '物联信报箱' || authUserform.device_type_code == 'OFFICIALDEPOSIT') && authStep == '1'">
          <p class="btn btn-confirm" @click="authStep = '2'">上一步</p>
        </template>
        <p class="btn btn-confirm" @click="submitAdd('form2')" v-if="authStep == '1'">确定</p>
      </span>
    </el-dialog>

    <!--设置管理员-->
    <el-dialog class="DkbInnerDialog authDio" title="设置管理员" :visible.sync="setAdminDio" append-to-body>
      <div class="contDio">
        <el-form ref="form3" :model="authform">
          <p class="tit">设备信息</p>
          <el-form-item class="deviceInfo">
            <div class="flex">
              <div class="item">设备ID：<span>{{authform.device_no_id}}</span></div>
              <div class="item">设备名称：<span>{{authform.device_name}}</span></div>
              <div class="item">设备类型：<span>{{authform.device_type}}</span></div>
            </div>
          </el-form-item>
        </el-form>
        <div class="tit3">授权用户:</div>
        <div class="authUserList flex">
          <div class="userTree DkbScroll">
            <el-tree ref="tree2" class="defineTree" :data="authform.department" highlight-current default-expand-all
              node-key="id" :expand-on-click-node="false" :props="adminTreeProp" @node-click="userClick">
              <span class="custom-tree-node" slot-scope="{ node }">
                <i class="defineIcon"
                  :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                </i>
                <span class="label">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
          <div class="checkList2 DkbScroll">
            <!-- 车位锁显示 -->
            <div class="topArea" v-if="authform.device_type_code == 'CPL'">
              <div class="search">
                <el-input size="small" placeholder="请输入姓名或手机号进行搜索" prefix-icon="el-icon-search"
                  v-model="authform.search" @input="searchAdminUser"></el-input>
              </div>
              <div class="titArea">
                <p class="left">姓名</p>
                <p class="right">授权功能点</p>
              </div>
            </div>
            <div class="checkItemBox" :class="[authform.device_type_code]">
              <div class="checkItem" v-for="(item,index) in authform.checkList" :key="index"
                @click="authform.activeIndex = index">
                <el-checkbox class="checkbox user_name" v-model="item.userChecked" @change="userCheckedChange">
                  {{item.user_name}}</el-checkbox>
                <template v-if="authform.device_type_code == 'CPL'">
                  <el-checkbox class="checkbox switch" v-model="item.switchChecked" @change="switchCheckedChange">开关
                  </el-checkbox>
                  <el-checkbox class="checkbox authorize" v-model="item.authorizeChecked"
                    @change="authorizeCheckedChange">授权</el-checkbox>
                </template>
              </div>
            </div>
            <!-- <el-checkbox-group v-model="authform.userInfo">
                    <el-checkbox v-for="(item,index) in checkList" :key="index" :label="item.user_id">{{item.user_name}}</el-checkbox>
                </el-checkbox-group> -->
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <p class="btn btn-confirm" @click="addDeviceAdmin">确定</p>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { showToast, updataBreadCrumb, deepCopy } from "../../../../../static/js/utility/utility.js"
import { userApi, sceneApi, authApi } from "../../../../../static/js/api.js"
let vm

export default {
  name: 'DkbAuthorizationManage',
  components: {
  },
  data () {
    return {
      authData: [],
      authMData: { // 授权管理数据
        // 分页数据
        paging: {
          page: 1,
          perPage: 8,
          search: ''
        },
        loading: false
      },

      checkList: [],
      // 树形控件配置
      defaultProps: {
        id: 'space_id',
        children: 'children',
        label: 'space_name'
      },

      space_id: [],//空间id
      authData: [],//授权列表
      tableLoading: false,//table是否刷新
      //分页
      curr: 1,//当前页
      page: 10,//显示个数
      total: 0,//总数据

      batchAuthDio: false,//批量弹窗状态
      actStep: 0,//步骤
      equipData: [],//设备数据
      bacthform: {
        timeType: '0',//时间类型
        time: '',//时间段
        frequency: '',//使用次数
        isCount: true,//是否无限次数
        userType: '0',//授权用户
        department: [],
        userInfo: [],
        deviceSeList: [],//选中设备
        search: '',//搜索字段
        authUserType: '0',
        device_type_code: '',
      },
      checkAllBatch: false,
      isIndeterminateBatch: false,

      total_equi: 0,//总设备数
      area_name: '',//地址
      departBacthList: [],
      isNoStep: false,//下一步是否置灰

      batchData: [],//批量列表

      //时间类型数组
      typeList: [{
        id: '1',
        name: '指定时间',
      }, {
        id: '0',
        name: '永久',
      }],
      //授权用户数组
      ustypeList: [{
        id: '0',
        name: '内部员工',
      },
      // {
      //   id:'1',
      //   name:'会员用户',
      // },
      {
        id: '2',
        name: '临时用户',
      }],
      departList: [],//部门级联列表
      //级联选择器配置
      cascaProps: {
        value: 'id',
        label: 'name',
      },
      //穿梭框渲染函数
      transList: [],
      //穿梭框配置
      transProps: {
        key: 'user_id',
        label: 'user_name',
      },

      AuthDio: false,//用户授权弹窗
      authUserform: {
        space_id: '',//空间id
        device_no_id: '',//设备号
        device_type: '',//设备类型
        device_name: '',//设备名
        timeType: '0',//时间类型
        time: '',//时间段
        frequency: '',//使用次数
        isCount: true,//是否无限次数
        is_forbid: false, // 是否禁止分享设备权限
        userType: '0',//授权用户
        department: [],
        userInfo: [],//勾选中列表
        boxNum: '',//箱格号
        search: '',//搜索字段
        authUserType: '0',
        device_type_code: '',
        current_count: '', // 当前授权人数（办公寄存柜专用）
        count: '',  // 可授权总人数（办公寄存柜专用）
      },
      boxList: [],//箱格列表
      allAuthUser: [],
      checkAll: false,
      isIndeterminate: false,
      authStep: '1',
      treeCurrent: '',

      rules2: {
        frequency: [
          { required: true, message: '请输入使用次数', trigger: 'blur' },
        ]
      },

      setAdminDio: false,//设置管理员弹窗
      authform: {
        activeIndex: '',
        search: '', // 用户列表搜索关键字
        space_id: '',//空间ID
        device_no_id: '',//设备号
        device_type: '',//设备类型
        device_type_code: '', //设备类型code
        device_name: '',//设备名
        department: [],
        checkList: [],
        userInfo: [],
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的 
        }
      },
      adminTreeProp: {
        id: 'id',
        label: 'name',
        children: 'children',
      },
      definSele: [],


    }
  },
  created () {
    vm = this
    vm.getSpaceDeviceList()
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    // 去企业后台更多设置
    goMore () {
      let navBarActive = [{ function_tab: 'CSceneManage', function_name: '控制中心' }, { function_tab: 'CAuthorizationCenter', function_name: '授权管理' }]
      // 更新面包屑内容
      updataBreadCrumb(2, navBarActive)
      vm.$router.push({ path: '/CAuthorizationCenter' })
    },
    //箱格授权
    authBox (boxnumber) {
      this.getDepartmentList(2);
      this.authStep = '1'
      this.authUserform.userInfo = []
      this.isIndeterminate = false
      this.authUserform.boxNum = boxnumber
    },

    //全选(批量)
    handleCheckAllBatch (val) {
      // console.log('全选',val)
      var arr = []
      for (var i in this.transList) {
        arr.push(this.transList[i].user_id)
      }
      arr = Array.from(new Set(arr))
      // console.log(arr)
      this.bacthform.userInfo = val ? arr : [];
      this.isIndeterminateBatch = false;
    },
    //选择多个（批量）
    handleCheckedCitiesBatch (value) {
      // console.log('单选',value)
      let checkedCount = value.length;
      this.checkAllBatch = checkedCount === this.transList.length;
      this.isIndeterminateBatch = checkedCount > 0 && checkedCount < this.transList.length;
    },

    //全选
    handleCheckAllChange (val) {
      console.log('全选', val)
      var arr = []
      this.transList.forEach((item, i) => {
        if (this.authUserform.device_type_code === 'FEIBIFACE') {
          if (item.is_face === 1) { arr.push(item.user_id) }
        } else {
          arr.push(item.user_id)
        }
      })
      arr = Array.from(new Set(arr))
      // console.log(arr)
      this.authUserform.userInfo = val ? arr : []
      this.isIndeterminate = false
    },
    //选择多个
    handleCheckedCitiesChange (value) {
      // console.log('单选',value)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.transList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.transList.length;
    },
    //设置表格多选框是否可选
    checkboxT (row, index) {
      console.log('tag', row)
      // 只有周转柜、门禁和插座可勾选批量授权
      if (row.device_type_code == 'TURN' || row.device_type_code == 'ACCESS' || row.device_type_code == 'SOCKET') {
        return true
      } else {
        return false
      }
    },
    //获取table选中
    handleSelectionChange (val) {
      this.batchData = val;
    },
    //提交批量授权
    submitBacth (formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.batchAddAuthorizedUser();
        } else {
          return false;
        }
      });
    },
    //添加批量授权
    async batchAddAuthorizedUser () {
      let that = this;
      var data = {
        'space_id': that.space_id.join(''),
        'device_no_id': that.bacthform.deviceSeList,
        // 'use_count': that.bacthform.frequency,
        'use_timetype': that.bacthform.timeType,
        'user_type': that.bacthform.userType,
        'user_list': that.bacthform.userInfo,
      }
      if (that.bacthform.isCount == true) {
        data.use_count = '-1'
      } else {
        var re = /^[1-9]+[0-9]*]*$/
        if (!re.test(that.bacthform.frequency)) {
          showToast('使用次数只能输入正整数')
          return
        } else {
          data.use_count = that.bacthform.frequency
        }
      }
      if (that.bacthform.timeType == 1) {
        data.start_usetime = that.bacthform.time[0];//开始时间
        data.end_usetime = that.bacthform.time[1];//结束时间
      }
      let res = await authApi.batchAddAuthorizedUser(data)
      if (res.meta.code === 200) {

        that.batchAuthDio = false;
        showToast('批量添加成功！')
      } else {
        showToast(res.meta.message)
      }
    },

    //下一步
    nextStep () {
      let that = this;
      that.batchData.forEach(function (value) {
        that.bacthform.deviceSeList.push(value.device_no_id)
      });
      that.getDepartmentList(1)
      that.actStep = 1
    },
    //删除设备
    delbacthDevice (index) {
      if (this.batchData.length <= 1) {
        showToast('最少保留一个设备！')
      } else {
        this.batchData.splice(index, 1);
      }

    },
    //打开批量弹窗
    openBatchAuth () {
      if (this.batchData == '') {
        showToast('请先勾选要授权的设备')
        // this.$message.warning('请先勾选要授权的设备')
        return
      }
      this.actStep = 0;//步骤
      this.equipData = [];//设备数据
      this.bacthform = {
        timeType: '0',//时间类型
        isCount: true,//是否无限次数
        userInfo: [],
        deviceSeList: [],//选中设备
        search: '',//搜索字段
      }
      this.checkAllBatch = false
      this.isIndeterminateBatch = false

      this.getSpaceDeviceAll();
      this.batchAuthDio = true;

    },
    //通过位置获取所有设备
    async getSpaceDeviceAll () {
      let that = this;
      let data = {
        'space_id': that.space_id.join(''),
      }
      let res = await authApi.getSpaceDeviceAll(data)
      if (res.meta.code === 200) {
        that.equipData = res.data.list
        that.total_equi = parseInt(res.data.count)
        that.area_name = res.data.area_name.replace(/\//g, "")
        if (res.data.list == '') {
          that.isNoStep = true;
        } else {
          that.isNoStep = false;
        }
      } else {
        showToast(res.meta.message)
      }
    },
    //提交管理员
    async addDeviceAdmin () {
      let that = this;
      // 获取要设置的用户列表
      let checkList = that.checkList, user_list = []
      checkList.forEach((item, index) => {
        let userItem = {}
        if (item.userChecked) {
          userItem = {
            user_id: item.user_id,
            auth_node: (item.switchChecked && item.authorizeChecked) ? 0 :
              (!item.switchChecked && item.authorizeChecked) ? 1 :
                (item.switchChecked && !item.authorizeChecked) ? 2 : ''
          }
          user_list.push(userItem)
        }
      })

      let data = {
        'space_id': that.authform.space_id,
        'device_no_id': that.authform.device_no_id,
        'user_list': user_list,
      }

      // if(data.user_list.length == 0){
      //   showToast('请选择管理员！')
      //   return
      // }

      // console.log('data', data)
      // return
      let res = await authApi.addDeviceAdmin(data)
      if (res.meta.code === 200) {
        that.authform = {
          activeIndex: '',
          search: '', // 用户列表搜索关键字
          space_id: '',//空间ID
          device_no_id: '',//设备号
          device_type: '',//设备类型
          device_type_code: '',//设备类型
          device_name: '',//设备名
          department: [],
          userInfo: [],
          checkList: []
        };
        that.setAdminDio = false
        showToast('设置成功！')
      } else {
        showToast(res.meta.message)
      }
    },
    //设置管理员-选择部门
    userClick (data) {
      // console.log(data)
      this.getUserToDepart(data.id)
    },
    //打开管理员设置
    async openAdminDio (index) {
      this.authform.search = ''
      this.authform.space_id = this.authData[index].space_id
      this.authform.device_no_id = this.authData[index].device_no_id
      this.authform.device_type = this.authData[index].device_type
      this.authform.device_type_code = this.authData[index].device_type_code
      this.authform.device_name = this.authData[index].device_name
      this.getDepartmentList(3);
      this.getUserToDepart(0)
      this.setAdminDio = true;
    },
    // 关键字搜索用户（手机号、名称）
    searchAdminUser () {
      let vm = this
      // console.log('keywords', vm.authform.search)
      let keywords = vm.authform.search
      let checkList = [...vm.checkList]
      let newList = []
      vm.authform.checkList = []
      checkList.forEach(function (item, index) {
        let newItem = {}
        if (item.phone_no.includes(keywords)) { newItem = item }
        if (item.user_name.includes(keywords)) { newItem = item }
        if (newItem.user_id) { newList.push(newItem) }
        // console.log('newItem', newItem)
      })
      vm.authform.checkList = newList
      // console.log('newList', newList)
    },
    // 通过部门获取用户（设置管理员）
    async getUserToDepart (departId) {
      let that = this;
      let data = {
        'device_no_id': that.authform.device_no_id,
        'department_id': departId,
      }
      let res = await authApi.getAdminUserList(data)
      if (res.meta.code === 200) {
        let list = [...res.data.list]
        res.data.list.forEach(function (value, index) {
          // console.log(value.is_admin)
          let auth_node = value.auth_node
          list[index].userChecked = value.is_admin == 1
          list[index].switchChecked = (value.is_admin == 1) && (auth_node == 0 || auth_node == 2)
          list[index].authorizeChecked = (value.is_admin == 1) && (auth_node == 0 || auth_node == 1)
        })
        that.checkList = list
        that.authform.checkList = list
        console.log('所有用户列表', list)
        // console.log(that.authform.userInfo)
      } else {
        showToast(res.meta.message)
      }
    },
    // 监听是否选择用户名称
    userCheckedChange (value) {
      let vm = this
      let index = vm.authform.activeIndex
      let newItem = vm.authform.checkList[index]
      let userChecked = newItem.userChecked
      // 若选择用户，默认勾选开关和授权的两个权限
      newItem.switchChecked = userChecked
      newItem.authorizeChecked = userChecked
      vm.$set(vm.authform.checkList, index, newItem)
      vm.checkListChange(newItem)
    },
    // 监听是否选择用户开门
    switchCheckedChange (value) {
      let vm = this
      let index = vm.authform.activeIndex
      let newItem = vm.authform.checkList[index]
      let authorizeChecked = newItem.authorizeChecked
      newItem.userChecked = authorizeChecked == false && value == false ? false : true
      vm.$set(vm.authform.checkList, index, newItem)
      vm.checkListChange(newItem)
    },
    // 监听是否选择用户授权
    authorizeCheckedChange (value) {
      let vm = this
      let index = vm.authform.activeIndex
      let newItem = vm.authform.checkList[index]
      let switchChecked = newItem.switchChecked
      newItem.userChecked = switchChecked == false && value == false ? false : true
      vm.$set(vm.authform.checkList, index, newItem)
      vm.checkListChange(newItem)
    },
    // 所有的用户列表变化
    checkListChange (newItem) {
      let vm = this
      if (vm.authform.search === '') { return }
      let CIndex
      vm.checkList.forEach((item, i) => {
        if (item.user_id === newItem.user_id) {
          CIndex = i
        }
      })
      vm.$set(vm.checkList, CIndex, newItem)
    },


    //添加授权用户
    submitAdd (formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.addAuthorizedUser();
        } else {
          return false;
        }
      });
    },
    async addAuthorizedUser () {
      let that = this;
      var data = {
        'space_id': that.authUserform.space_id,//空间id
        'device_no_id': that.authUserform.device_no_id,//设备号
        // 'use_count': that.authUserform.frequency,//使用次数
        'use_timetype': that.authUserform.timeType,//授权时间类型
        'user_type': that.authUserform.userType,//用户类型
        'user_list': that.authUserform.userInfo,//用户id
        'is_share': that.authUserform.is_forbid ? 0 : 1, // 是否禁止分享(1允许分享，0不允许)
      }
      //判断是否是魔方柜或者信报箱
      if (that.authUserform.device_type_code == 'MAGICCUBE' || that.authUserform.device_type_code == 'IOTLETTERBOX' || that.authUserform.device_type_code == 'OFFICIALDEPOSIT') {
        data.box_number = that.authUserform.boxNum;//箱格号
        if (that.authUserform.device_type_code == 'OFFICIALDEPOSIT' && that.authUserform.current_count == 150) {
          showToast('此设备授权人数已达到上限150人')
          return
        }
      }
      if (that.authUserform.isCount == true) {
        data.use_count = '-1'
      } else {
        var re = /^[1-9]+[0-9]*]*$/
        if (!re.test(that.authUserform.frequency)) {
          showToast('使用次数只能输入正整数')
          return
        } else {
          data.use_count = that.authUserform.frequency
        }
      }
      if (that.authUserform.timeType == 1) {
        data.start_usetime = that.authUserform.time[0];//开始时间
        data.end_usetime = that.authUserform.time[1];//结束时间
      }
      let res = await authApi.addAuthorizedUser(data)
      if (res.meta.code === 200) {
        that.closeAuthDio()
        // showToast(res.meta.message)
        showToast('授权用户成功！')
      } else {
        showToast(res.meta.message)
      }
    },
    //打开用户授权
    openAuthDio (index) {
      this.authUserform = {
        timeType: '0',//时间类型
        isCount: true,//是否无限次数
        userInfo: [],//勾选中列表
        boxNum: '',//箱格号
        search: '',//搜索字段
        is_forbid: false, // 是否禁止分享
      }
      this.boxList = [];//箱格列表
      this.allAuthUser = []
      this.checkAll = false;
      this.isIndeterminate = false;
      this.authStep = '1'
      this.authUserform.space_id = this.authData[index].space_id
      this.authUserform.device_no_id = this.authData[index].device_no_id
      this.authUserform.device_type = this.authData[index].device_type
      this.authUserform.device_name = this.authData[index].device_name
      this.authUserform.device_type_code = this.authData[index].device_type_code
      //判断是否是魔方柜、信报箱或办公寄存柜
      let codeValue = this.authUserform.device_type_code
      if (codeValue == 'MAGICCUBE' || codeValue == 'IOTLETTERBOX' || codeValue == 'OFFICIALDEPOSIT') {
        this.authStep = '2'
        this.getAuthBox(this.authData[index].device_no_id)
      } else {
        this.getDepartmentList(2);
      }
      this.AuthDio = true;
    },
    //获取箱格授权信息
    async getAuthBox (id) {
      let that = this;
      const dataObj = {
        'device_no_id': id,
      }
      const res = await authApi.getAuthBox(dataObj);
      if (res.meta.code == 200) {
        that.boxList = [...res.data.list]
        that.authUserform.current_count = res.data.current_count
        that.authUserform.count = res.data.count
      } else {
        showToast(res.meta.message);
      }
    },
    //关闭用户授权
    closeAuthDio () {
      let that = this;
      if (this.AuthDio == true) {
        that.authUserform = {
          device_no_id: '',//设备号
          device_type: '',//设备类型
          device_name: '',//设备名
          timeType: '1',//时间类型
          time: '',//时间段
          frequency: '',//使用次数
          isCount: false,//是否无限次数
          userType: '0',//授权用户
          department: [],
          userInfo: [],
        };
        that.departList = [];
        that.transList = [];
        that.AuthDio = false;
      } else if (this.batchAuthDio == true) {
        that.bacthform = {
          timeType: '1',//时间类型
          time: '',//时间段
          frequency: '',//使用次数
          isCount: false,//是否无限次数
          userType: '0',//授权用户
          department: [],
          userInfo: [],
          deviceSeList: [],//选中设备
        };
        that.departBacthList = [];
        that.transList = [];
        that.batchAuthDio = false;
      }
    },
    //穿梭框数据列渲染
    renderFunc (h, option) {
      return h('span', option.phone_no + '-' + option.user_name)
    },
    //穿梭框自定义搜索逻辑
    filterMethod (query, item) {
      // console.log(query,item)
      return item.phone_no.indexOf(query) > -1 || item.user_name.indexOf(query) > -1;
    },

    //获取用户列表
    async getUserList (node) {
      // console.log(node)
      let that = this;
      this.treeCurrent = node.id
      let data = {}
      if (that.batchAuthDio == true) {
        // data.user_type = that.bacthform.userType;
        if (that.bacthform.authUserType != node.userType) {
          that.bacthform.userInfo = []
          that.isIndeterminateBatch = false
        }
        that.bacthform.authUserType = node.userType
        data.user_type = node.userType
        data.is_bath = true;
        data.space_id = that.space_id.join('');
        if (node.userType == 0) {
          data.department_id = node.id
        }
      } else {
        if (that.authUserform.authUserType != node.userType) {
          that.authUserform.userInfo = []
          that.isIndeterminate = false
        }
        that.authUserform.authUserType = node.userType
        data.user_type = node.userType
        data.is_bath = false;
        data.space_id = that.authUserform.space_id;
        data.device_no_id = that.authUserform.device_no_id;
        data.box_number = that.authUserform.boxNum;
        if (node.userType == '0') {
          if (node.id == '-1') {
            data.department_id = '0'
          } else {
            data.department_id = node.id
          }
        }
      }
      let res = await authApi.getUserList(data)
      if (res.meta.code === 200) {
        // console.log(res.data.list)
        // that.transList = res.data.list
        that.allAuthUser = res.data.list
        that.searchUser()
      } else {
        showToast(res.meta.message)
      }
    },
    //筛选用户
    searchUser () {
      let that = this;
      var allAuthUser = this.allAuthUser
      var searchList = []
      for (var i in allAuthUser) {
        if (that.authUserform.search != '') {
          if (allAuthUser[i].user_name.indexOf(that.authUserform.search) != -1) {
            searchList.push(allAuthUser[i])
          }
        } else if (that.bacthform.search != '') {
          if (allAuthUser[i].user_name.indexOf(that.bacthform.search) != -1) {
            searchList.push(allAuthUser[i])
          }
        } else {
          searchList = allAuthUser
        }
      }
      // console.log('searchList',searchList)
      this.transList = searchList
    },
    //递归遍历树形数组
    forTree (data) {
      var that = this
      for (var i in data) {
        data[i].userType = '0'
        if (data[i].children) {
          that.forTree(data[i].children)
        }
      }
    },
    //获取部门列表
    async getDepartmentList (status) {
      let that = this
      let res = await userApi.getDepartmentList()
      if (res.meta.code === 200) {
        if (status == 3) {
          that.authform.department = res.data
          that.definSele = res.data[0].id.split(',')
        } else if (status == 2 || status == 1) {
          that.departList = []
          that.departBacthList = []
          var arr = []
          that.forTree(res.data)
          const obj = {
            id: '-1',
            name: '内部员工',
            children: res.data,
            userType: '0',
          }
          arr.push(obj)
          const obj2 = {
            id: '-2',
            name: '临时员工',
            userType: '2'
          }
          arr.push(obj2)

          if (status == '2') {
            that.departList = arr
          } else {
            that.departBacthList = arr
          }
          that.getUserList(obj)

        }
      } else {
        showToast(res.meta.message)
      }
    },
    //查看已授权用户
    toBeauthUser (index) {
      let that = this;
      let navBarActive = [{ function_tab: 'CBeAuthorizedUser', function_name: '已授权用户' }]
      // 更新面包屑内容
      updataBreadCrumb(3, navBarActive)
      this.$router.push({
        path: '/CBeAuthorizedUser',
        query: {
          'space_id': that.authData[index].space_id,
          'device_no_id': that.authData[index].device_no_id,
          'device_type': that.authData[index].device_type,
          'device_name': that.authData[index].device_name,
        }
      })
    },

    //关闭用户授权
    closeAuthDio () {
      let that = this;
      if (this.AuthDio == true) {
        that.authUserform = {
          device_no_id: '',//设备号
          device_type: '',//设备类型
          device_name: '',//设备名
          timeType: '1',//时间类型
          time: '',//时间段
          frequency: '',//使用次数
          isCount: false,//是否无限次数
          userType: '0',//授权用户
          department: [],
          userInfo: [],
        };
        that.departList = [];
        that.transList = [];
        that.AuthDio = false;
      } else if (this.batchAuthDio == true) {
        that.bacthform = {
          timeType: '1',//时间类型
          time: '',//时间段
          frequency: '',//使用次数
          isCount: false,//是否无限次数
          userType: '0',//授权用户
          department: [],
          userInfo: [],
          deviceSeList: [],//选中设备
        };
        that.departBacthList = [];
        that.transList = [];
        that.batchAuthDio = false;
      }
    },
    // 获取当前公司的设备列表
    async getSpaceDeviceList (search) {
      let data = vm.authMData.paging
      if (search) { data.page = 1 }

      vm.authMData.loading = true
      let res = await sceneApi.getSpaceDeviceList(data)
      vm.authMData.loading = false
      if (res.meta.code === 200) {
        vm.authData = [...res.data.list]
        vm.authMData.pageCount = res.data.pageCount
      } else {
        showToast(res.meta.message)
      }
    },
    // 列表当前页值改变，获取新设备列表
    pageChange (val) {
      this.getSpaceDeviceList()
    },
  },
  watch: {
    // 监听tab用户的搜索字段user_name为空，获取新的用户列表
    'authMData.paging.search': function (newVal) {
      if (newVal === '') {
        this.getSpaceDeviceList()
      }
    },

    //设置管理员弹窗树形默认选中
    definSele () {
      let that = this;
      this.$nextTick(function () {
        that.$refs.tree2.setCurrentKey(that.definSele.join(''))
      })
    }
  }
}

</script>

<style lang="scss">
.DkbAuthorizationManage {
  width: 9.8rem;
  margin: 0 auto;
  .operateArea {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .searchArea {
      flex-shrink: 0;
      display: flex;
      .text {
        width: 6rem;
        .el-input__inner {
          height: 0.36rem;
          line-height: 0.36rem;
          color: #a6aeb8;
          border: none;
          border-radius: 0.04rem;
          background-color: #34526e;
        }
        .el-input__inner::placeholder {
          color: #a6aeb8;
        }
      }
      .text + .text {
        margin-left: 0.15rem;
      }
      .btn-search {
        display: block;
        height: 0.36rem;
        line-height: 0.36rem;
        margin-left: 0.25rem;
        padding: 0 0.1rem;
        border-radius: 0.04rem;
        color: #ffffff;
        background-color: #1993d9;
      }
    }
    .btnArea {
      display: flex;
      .btn {
        width: 1.17rem;
        height: 0.37rem;
        background: url(/static/images/dkb/dialog/btn_bg.png) center no-repeat;
        background-size: 100% 100%;
        text-align: center;
        line-height: 0.37rem;
        font-size: 0.14rem;
        color: #ffffff;
      }
    }
  }
  .listBox {
    margin-top: 0.37rem;
    padding: 0.41rem 0.51rem 0;
    border-radius: 0.1rem;
    border: 0.02rem solid #7ca8cf;
    box-sizing: border-box;
    box-shadow: 0 0 0.34rem rgba(0, 0, 0, 0.2),
      0 0 0.19rem rgba(140, 199, 252, 0.16) inset;
    .listWrapper {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .list {
        width: 1.83rem;
        height: 1.28rem;
        margin-right: 0.46rem;
        margin-bottom: 0.32rem;
        padding: 0.13rem 0.08rem 0;
        box-sizing: border-box;
        border-radius: 0.05rem;
        border: 0.02rem solid #7ca8cf;
        box-shadow: 0 0 0.34rem rgba(0, 0, 0, 0.2),
          0 0 0.19rem rgba(140, 199, 252, 0.16) inset;
        display: flex;
        flex-direction: column;
        .one {
          display: flex;
          .num {
            flex-shrink: 0;
            width: 0.37rem;
            height: 0.22rem;
            line-height: 0.22rem;
            font-size: 0.12rem;
            color: #082e50;
            background-color: #ffffff;
            border-radius: 0.04rem;
            text-align: center;
          }
          .name {
            font-size: 0.14rem;
            margin-left: 0.1rem;
            color: #ffffff;
            max-width: 1.5rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
        }
        .two {
          margin-top: 0.1rem;
          font-size: 0.12rem;
          line-height: 0.18rem;
          color: #cccccc;
          .text.device_name {
            max-width: 1.63rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
          .blue {
            color: #7ca8cf;
          }
        }
        .three {
          margin-top: 0.13rem;
          display: flex;
          justify-content: space-between;
          .btn {
            width: 0.8rem;
            height: 0.25rem;
            line-height: 0.25rem;
            border-radius: 0.25rem;
            border: 0.01rem solid #54c3e2;
            text-align: center;
            color: #64ceee;
            font-size: 0.12rem;
          }
          .btn + .btn {
            // margin-left: 0.07rem;
          }
        }
      }
      .list:nth-child(4n) {
        margin-right: 0;
      }
    }
    .dkbPagination {
      margin: 0.24rem 0 0.3rem;
    }
  }
}
// 通用
.DkbInnerDialog > .el-dialog {
  width: 7.95rem;
  .el-dialog__body {
    color: #ffffff;
    padding: 0.2rem 0.3rem 0.3rem 0.4rem;
  }
  .deviceInfo {
    width: 100%;
    padding-bottom: 0.1rem;
    border-bottom: 0.01rem solid #566989;
    .tit {
      // color: #ffffff;
      font-size: 0.16rem;
      line-height: 0.22rem;
    }
    .flex {
      display: flex;
      .item {
        font-size: 0.14rem;
        line-height: 0.24rem;
        color: #cccccc;
      }
      .item + .item {
        margin-left: 0.3rem;
      }
    }
  }
}
// 授权用户
.DkbInnerDialog.authDio > .el-dialog {
  // 箱格授权用户
  .dioTit {
    width: 100%;
    margin: 0.18rem 0 0.17rem;
    display: flex;
    justify-content: space-between;
    .text {
      font-size: 0.16rem;
      line-height: 0.22rem;
      color: #ffffff;
    }
  }
  .dioList {
    display: flex;
    flex-wrap: wrap;
    .item:nth-child(4n) {
      margin-right: 0;
    }
    .item {
      width: 1.35rem;
      height: 1.37rem;
      margin-right: 0.5rem;
      margin-bottom: 0.4rem;
      border-radius: 0.05rem;
      border: 0.01rem solid #80abd7;
      box-shadow: 0 0 0.19rem rgba(140, 199, 252, 0.16) inset;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .size {
        flex-shrink: 0;
        width: 0.45rem;
        height: 0.45rem;
        line-height: 0.45rem;
        border-radius: 50%;
        font-size: 0.14rem;
        color: #ffffff;
        text-align: center;
      }
      .size.A {
        background-color: #072c4e;
      }
      .size.B {
        background-color: #395ffd;
      }
      .size.C {
        background-color: #229fff;
      }
      .size.D {
        background-color: #51c1e1;
      }
      .size.E {
        background-color: #072c4e;
      }
      .des {
        flex-shrink: 0;
        margin: 0.1rem 0 0.12rem;
        font-size: 0.12rem;
        line-height: 0.16rem;
        color: #cccccc;
        .num {
          margin-right: 0.08rem;
        }
      }
      .btn-auth {
        flex-shrink: 0;
        width: 0.83rem;
        height: 0.25rem;
        line-height: 0.23rem;
        text-align: center;
        border-radius: 0.25rem;
        border: 0.01rem solid #51c1e1;
        color: #64ceee;
      }
    }
  }
  .authInfo {
    .el-form-item__content {
      display: flex;
      align-items: center;
    }
    .tit2 {
      font-size: 0.14rem;
      color: #ffffff;
      margin-right: 0.1rem;
    }
    .w110 {
      width: 1.1rem;
      // height: 0.3rem;
    }
    .inputbg {
      border-color: #a0a0a0;
      background-color: #18376a;
      input {
        // height: 0.3rem;
        // line-height: 0.3rem;
        border-color: #a0a0a0;
        background-color: #18376a;
        color: #ffffff;
      }
      .el-range-separator {
        color: #c0c4cc;
      }
    }
    .datePicker {
      margin-left: 0.2rem;
    }
    .el-checkbox {
      color: #ffffff;
      .el-checkbox__inner {
        border-color: #ffffff;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        border-color: #409eff;
      }
    }
    .ci {
      color: #ffffff;
      margin-left: 0.1rem;
    }
  }
  .tit3 {
    display: flex;
    justify-content: space-between;
    font-size: 0.16rem;
  }
  // 通用
  .authUserList {
    width: 100%;
    height: 2.85rem;
    margin-top: 0.2rem;
    border: 0.02rem solid #80abd7;
    box-shadow: 0 0 0.34rem rgba(0, 0, 0, 0.2),
      0 0 0.19rem rgba(140, 199, 252, 0.16) inset;
    display: flex;
    .userTree {
      flex-shrink: 0;
      width: 2.83rem;
      height: 2.81rem;
      overflow-x: hidden;
      overflow-y: scroll;
      border-right: 0.02rem solid #80abd7;
      .el-tree.defineTree {
        color: #ffffff;
        background-color: #18376a;
        margin-top: 0;
        .custom-tree-node .label {
          color: #ffffff;
        }
        .el-tree-node:focus > .el-tree-node__content,
        .el-tree-node:hover > .el-tree-node__content,
        .el-tree-node.is-current > .el-tree-node__content {
          background-color: transparent !important;
        }
        .el-tree-node.is-current > .el-tree-node__content {
          .label {
            color: #409eff;
          }
        }
        // .el-tree-node__content:hover,
        // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {

        //   background-color: #18376a;
        // }
      }
    }
    .checkList {
      width: 100%;
      height: 2.81rem;
      padding: 0.2rem 0.3rem;
      overflow-x: hidden;
      overflow-y: scroll;
      .search {
        margin-bottom: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .el-input {
          width: 2.95rem;
          input {
            height: 0.3rem;
            border-color: #dbdee5;
            border-radius: 0.3rem;
            background-color: #18376a;
          }
        }
        .checkAll {
          .el-checkbox__inner {
            width: 0.19rem;
            height: 0.19rem;
          }
          .el-checkbox__inner::after,
          .el-checkbox__inner::before {
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
          }
          .el-checkbox__inner::after {
            height: 0.07rem;
          }
        }
      }
      .el-checkbox-group {
        display: flex;
        flex-direction: column;
        .el-checkbox {
          margin-right: 0;
          overflow: hidden;
          zoom: 1;
          &.is-disabled {
            opacity: 0.2;
          }
          .el-checkbox__label {
            float: left;
            color: #ffffff;
            font-size: 0.14rem;
            line-height: 0.37rem;
          }
          .el-checkbox__input {
            margin-top: 0.115rem;
            float: right;
            .el-checkbox__inner {
              width: 0.14rem;
              height: 0.14rem;
            }
            .el-checkbox__inner::after {
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
              height: 0.06rem;
            }
          }
        }
        .el-checkbox.is-checked {
          .el-checkbox__label {
            color: #409eff;
          }
        }
        .el-checkbox:after {
          content: " ";
          display: block;
          clear: both;
          height: 0;
          visibility: hidden;
          font-size: 0;
        }
      }
    }
  }
  // 设置管理员
  .authUserList {
    .checkList2 {
      width: 100%;
      height: 2.81rem;
      position: relative;
      display: flex;
      flex-direction: column;
      .topArea {
        flex-shrink: 0;
        // 搜索
        .search {
          width: 70%;
          margin: 0.1rem auto;
          input {
            border-radius: 32px;
            border-color: transparent;
          }
        }
        // 标题
        .titArea {
          padding: 0 0.2rem 0.1rem;
          border-bottom: 1px solid #eee;
          display: flex;
          .left {
            width: 50%;
            margin-right: 2%;
          }
        }
      }
      .checkItemBox {
        max-height: 100%;
        overflow-y: auto;
        padding: 0.1rem 0.2rem 0;
        display: flex;
        flex-wrap: wrap;
        &.CPL {
          display: block;
          .checkItem {
            width: 100%;
            display: flex;
            .checkbox {
              flex-shrink: 0;
              width: 20%;
              margin-right: 0.35rem;
              &.user_name {
                width: 50%;
                margin-right: 5%;
              }
              &.switch {
                margin-right: 5%;
              }
              .el-checkbox__label {
                color: #ffffff;
                font-size: 0.14rem;
                line-height: 0.37rem;
              }
              .el-checkbox__input {
                .el-checkbox__inner {
                  width: 0.14rem;
                  height: 0.14rem;
                }
                .el-checkbox__inner::after {
                  left: 0;
                  right: 0;
                  top: 0;
                  bottom: 0;
                  margin: auto;
                  height: 0.06rem;
                }
              }
            }
            .el-checkbox.is-checked {
              .el-checkbox__label {
                color: #409eff;
              }
            }
          }
        }
      }
    }
  }
}
.innerForm {
  padding-top: 0.16rem;
  color: #ffffff;
  .el-form {
    .el-form-item {
      .el-form-item__label {
        color: #ffffff;
        font-size: 0.16rem;
      }
      .inputBox {
        width: 4rem;
        height: 0.4rem;
        input {
          border: none;
          background-color: #2d5391;
          color: #ffffff;
        }
        input::placeholder {
          color: #a6aeb8;
        }
      }
    }
  }
  .dialog-footer {
    margin-top: 0.4rem;
    display: flex;
    justify-content: flex-end;
    .dbtn {
      display: block;
      width: 0.87rem;
      height: 0.37rem;
      line-height: 0.37rem;
      text-align: center;
      color: #072c4e;
      background-color: #ffffff;
      border-radius: 0.04rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/DialogPage/AuthorizationManage/AuthorizationManage.vue